module.exports = __webpack_public_path__ + "img/icon-download.17eee8e1.svg";